export default {
  '--app-primary-color': 'hsl(142, 45%, 26%)',
  '--app-secondary-color': 'hsl(142, 86%, 8%)',
  '--app-tertiary-color': 'hsl(143, 36%, 90%)',
  '--app-disabled-color': 'hsl(147, 31%, 93%)',
  '--sidebar-bg-color': 'hsl(142, 46%, 26%)',
  '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
  '--sidebar-text-color': 'hsl(0, 0%, 100%)',
  '--sidebar-active-bg-color': 'hsl(143, 36%, 90%)',
  '--sidebar-active-text-color': 'hsl(142, 86%, 8%)'
};